module.exports = {
    catalogUrl: null,
    catalogTitle: "Impact Observatory STAC Browser",
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [
        'api.impactobservatory.com'
    ],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
        "ar",
        //      "de-CH",
        "es",
        "en",
        //      "en-GB",
        //      "en-US",
        "fr",
        //      "fr-CA",
        //      "fr-CH",
        "it",
        //      "it-CH",
        "ro",
        "ja",
        "pt",
        //      "pt-BR"
        "id"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    displayGeoTiffByDefault: false,
    buildTileUrlTemplate: ({ href, asset }) => 'https://api.impactobservatory.com/titiler-internal/cog/tiles/{z}/{x}/{y}@2x?url=' + encodeURIComponent(asset.href.startsWith('/vsi') ? asset.href : href),
    stacProxyUrl: null,
    pathPrefix: "/",
    historyMode: "history",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showKeywordsInItemCards: false,
    showKeywordsInCatalogCards: false,
    showThumbnailsAsAssets: false,
    geoTiffResolution: 128,
    redirectLegacyUrls: false,
    itemsPerPage: 12,
    maxItemsPerPage: 1000,
    defaultThumbnailSize: null,
    maxPreviewsOnMap: 50,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    socialSharing: [],
    preprocessSTAC: null,
    authConfig: {
        type: 'apiKey',
        in: 'header',
        name: 'apikey',
    }
};
